import React, { useState } from "react";
import { TabPanel, TabView } from "primereact/tabview";
import { useNavigate } from "react-router-dom";

const SubContractorTab = ({ index, id }: any) => {
  const [activeIndex, setActiveIndex] = useState<number>(index);

  const navigate = useNavigate();

  const tabChange = (e: any) => {
    setActiveIndex(e.index);

    if (e?.index === 0) {
      navigate("/sub-contractor", { state: { clientId: id } });
    } else {
      navigate("/sub-contractor-payment", { state: { clientId: id } });
    }
  };

  return (
    <>
      <TabView activeIndex={activeIndex} onTabChange={(e) => tabChange(e)}>
        <TabPanel header="Sub Contractor"></TabPanel>
        <TabPanel header="Payment"></TabPanel>
      </TabView>
    </>
  );
};

export default SubContractorTab;
